module.exports = __webpack_public_path__ + "img/1.1504f07e.png";